module.exports = __webpack_public_path__ + "static/img/flag_sv.18be91e.svg";